import { CRUDEntity } from "../abstracts/CRUDEntity";

import { FormActions } from "../abstracts/mixins/FormActions";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { HasStatus } from "../abstracts/mixins/HasStatus";
import { HasWorkers } from "../abstracts/mixins/HasWorkers";
import { HasComments } from "../abstracts/mixins/HasComments";
import { HasAttachments } from "../abstracts/mixins/HasAttachments";

export class Order extends CRUDEntity {

    static #statuses = {
        WAITING:1,
        IN_PROGRESS:2,
        COMPLETED:3,
        ON_HOLD:4,
        CANCELED:5
    }

    static get statuses(){
        return this.#statuses
    }

    constructor(id=null) {
        super();
        this.entityClass = 'order';
        // See Job.js — /worker-cabinet/v2/... is the V2-owned attachment endpoint.
        this.urlRoot = /worker-cabinet/.test(location.href.split(/[\\\/]+/).pop()) ? '/worker-cabinet/v2/order' : '/service-list/order';
        this.sectionRootUrl = /worker-cabinet/.test(location.href.split(/[\\\/]+/).pop()) ? '/worker-cabinet' : '/service-list';
        this.id = id;

        Object.assign(Order.prototype, FormActions);
        Object.assign(Order.prototype, EntityModalForm);
        Object.assign(Order.prototype, HasStatus);
        Object.assign(Order.prototype, HasWorkers);
        Object.assign(Order.prototype, HasComments);
        Object.assign(Order.prototype, HasAttachments);

        this.setAttachmentCallbackDelete()
        this.setAttachmentCallbackPreview();
    }
}
